import {IcnArrowRightUp, IcnInfoFilled, IcnSwitchHorizontal} from "../../assets/icons";

import * as Yup from 'yup'
import {Form, Formik} from "formik";
import Tippy from "@tippyjs/react";

import {DummyCurrencyOptions, HomePayFeeFormOnRampValues,} from "../../utils";

import ModalFormWrapper from "../common/ModalFormWrapper";
import FormFieldset from "../form-elements/FormFieldset";
import FormInputNumber from "../form-elements/FormInputNumber";
import FormInputSelect from "../form-elements/FormInputSelect";
import FormGroupErrorText from "../form-elements/FormGroupErrorText";
import BlockNumber from "../common/BlockNumber";
import BlockTokenPair from "../common/BlockTokenPair";
import Button from "../common/Button";


interface HomePayFeeFormOnRampStep0Props {
  data: HomePayFeeFormOnRampValues;
  next: (values: HomePayFeeFormOnRampValues) => void;
  handleBack: () => void;
  onCloseModal: () => void;
}

const HomePayFeeFormOnRampStep0Schema = Yup.object().shape({
  amount: Yup.number().required('Please enter an amount to proceed.'),
  fiatCurrency: Yup.string().required("Please select currency to proceed."),
  tokens: Yup.array().of(Yup.string()).notRequired()
})

function HomePayFeeFormOnRampStep0(
  {
    data,
    next,
    handleBack,
    onCloseModal,
  }:HomePayFeeFormOnRampStep0Props) {

  const FIATCURRENCY = data.fiatCurrency.toUpperCase();
  const TOKENCURRENCY = data.tokens[0];

  return (
    <Formik
      initialValues={data}
      validationSchema={HomePayFeeFormOnRampStep0Schema}
      onSubmit={(values) => {
        next(values)
      }}
    >
      {({ isSubmitting, values, errors, touched }) => (

        <Form
          className="c-form"
          noValidate
        >

          <ModalFormWrapper
            headerTitle="Pay fee through On-Ramp"
            onClick={handleBack}
            onCloseModal={onCloseModal}
          >
            <FormFieldset
              extraClassName="amount"
              legendText="Enter amount"
            >

              <FormInputNumber
                extraClassName="amount boxed"
                formGroupStyle="block-line"
                name="amount"
                labelText="Amount"
                placeholder={`0.00 ${values.fiatCurrency? FIATCURRENCY : ""}`}
                inputGroupText="$ "
                inputGroupPlacement="left"
                suffix={` ${FIATCURRENCY}`}
                hideError
                decimalScale={2}
                fixedDecimalScale
                formGroupExtraContent={
                  <FormInputSelect
                    name="fiatCurrency"
                    labelText="Select currency"
                    labelIsHidden
                    options={DummyCurrencyOptions}
                    hideError
                    isDisabled
                  />
                }
              />

              {errors.amount && touched.amount && (
                <FormGroupErrorText text={errors.amount}/>
              )}

              {errors.fiatCurrency && touched.fiatCurrency && (
                <FormGroupErrorText text={errors.fiatCurrency}/>
              )}

              <FormInputNumber
                formGroupStyle="block-line"
                name="conversionRate"
                labelText="Conversion rate"
                value={45.14}
                inputGroupText="$ "
                inputGroupPlacement="left"
                suffix={` ${TOKENCURRENCY}`}
                disabled
                readOnly
                decimalScale={2}
                fixedDecimalScale
                formGroupExtraContent={
                  <BlockTokenPair
                    tokens={values.tokens}
                    tokenName={TOKENCURRENCY}
                  />
                }
              />

            </FormFieldset>

            <FormFieldset legendText="Details">

              <ul className="c-form-fieldset-detail-list">

                <li className="exchange-rate">
                  <em>Exchange rate</em>
                  <span>
                    <i><IcnSwitchHorizontal/></i>
                    <span>1 {FIATCURRENCY} = 1 {TOKENCURRENCY} <em>($1.00)</em></span>
                  </span>
                </li>

                <li style={{position: `relative`}}>
                  <em>
                    Estimated fees

                    <Tippy
                      placement="auto"
                      content="Lorem ipsum dolor sit amet, consectetur adipisicing elit. Autem expedita facilis incidunt inventore maiores modi nemo nisi quaerat reprehenderit sint. Harum impedit in incidunt mollitia quod rem unde? Consequatur, est!"
                      className="c-tooltip"
                    >
                      <i className="c-tooltip-icon"><IcnInfoFilled/></i>
                    </Tippy>
                  </em>

                  <BlockNumber
                    value={0}
                    prefix="$"
                    suffix=" USDC"
                    decimalScale={2}
                    fixedDecimalScale
                  />
                </li>

              </ul>

            </FormFieldset>

            <div className="c-modal-footer">
              <Button
                extraClassName="has-space-between"
                type="submit"
                text={`Complete transaction ${values.amount? `· $${values.amount} ${TOKENCURRENCY}`: ""}`}
                btnSize="lg"
                icon={<IcnArrowRightUp/>}
                disabled={isSubmitting}
              />
            </div>

          </ModalFormWrapper>

        </Form>
      )}

    </Formik>
  );
}

export default HomePayFeeFormOnRampStep0;